/**
 * Replacements for the jQuery effects fadeIn, fadeOut, slideDown and slideUp.
 * As in jQuery, effects on the same element are queued and run one after the other.
 */
const FADE_HIDDEN_STYLE = {opacity: '0'};
const SLIDE_HIDDEN_STYLE = {
    height: '0px',
    paddingTop: '0px',
    paddingBottom: '0px',
    marginTop: '0px',
    marginBottom: '0px',
};

const effectQueues = new WeakMap();

function runVisibilityEffect(element, show, hiddenStyle, duration, complete) {
    return new Promise((resolve) => {
        const finish = () => {
            if (complete) complete();
            resolve();
        };

        // Nothing to do when the element already is in the requested state
        const isHidden = window.getComputedStyle(element).display === 'none';
        if (isHidden !== show) {
            finish();
            return;
        }

        element.style.display = '';
        if (window.getComputedStyle(element).display === 'none') {
            element.style.display = 'block';
        }

        const computedStyle = window.getComputedStyle(element);
        const restingStyle = {};
        Object.keys(hiddenStyle).forEach((property) => {
            restingStyle[property] = computedStyle[property];
        });

        const isSlide = hiddenStyle === SLIDE_HIDDEN_STYLE;
        if (isSlide) {
            element.style.overflow = 'hidden';
        }

        const keyframes = show ? [hiddenStyle, restingStyle] : [restingStyle, hiddenStyle];
        const animation = element.animate(keyframes, {duration, easing: 'ease-in-out'});

        animation.onfinish = () => {
            if (isSlide) {
                element.style.overflow = '';
            }
            if (!show) {
                element.style.display = 'none';
            }
            finish();
        };
    });
}

function queueVisibilityEffect(element, show, hiddenStyle, duration, complete) {
    const queue = effectQueues.get(element) || Promise.resolve();
    effectQueues.set(element, queue.then(() => runVisibilityEffect(element, show, hiddenStyle, duration, complete)));
}

const fadeIn = (element, duration, complete) => queueVisibilityEffect(element, true, FADE_HIDDEN_STYLE, duration, complete);
const fadeOut = (element, duration, complete) => queueVisibilityEffect(element, false, FADE_HIDDEN_STYLE, duration, complete);
const slideDown = (element, duration, complete) => queueVisibilityEffect(element, true, SLIDE_HIDDEN_STYLE, duration, complete);
const slideUp = (element, duration, complete) => queueVisibilityEffect(element, false, SLIDE_HIDDEN_STYLE, duration, complete);

const trigger = (element, eventName) => element.dispatchEvent(new CustomEvent(eventName, {bubbles: true, cancelable: true}));


function init() {

    /**
     * Header nav menu
     */

    // Main nav
    const nav = document.querySelector('header .header-nav');

    if (nav) {
        const firstLevelParents = nav.querySelectorAll(':scope > ul > li.has-submenu');
        // const secondLevelParents = nav.querySelectorAll(':scope > ul > li.has-submenu > ul > li.has-submenu');
        const secondLevelParents = nav.querySelectorAll(':scope > ul > li.has-submenu li.has-submenu');

        // Mobile nav
        const mobileNavPlaceholder = document.querySelector('header .mobile-nav-placeholder');
        const mobileNav = nav.cloneNode(true);
        const mobileParents = mobileNav.querySelectorAll('li.has-submenu');
        const mobileLanguageChanger = document.querySelector('header .header-language-changer')?.cloneNode(true);
        const burgerButton = document.querySelector('header .burger-button');
        mobileNavPlaceholder.append(mobileNav);
        if (mobileLanguageChanger) {
            mobileNavPlaceholder.append(mobileLanguageChanger);
        }

        firstLevelParents.forEach((parent) => {

            const child = parent.querySelector(':scope > ul');
            const link = parent.querySelector(':scope > a');

            parent.addEventListener('nxb:open', (event) => {
                event.stopPropagation();
                event.preventDefault();
                // Open self
                parent.classList.add('open');
                child.classList.add('open');
                link?.classList.add('hover');
                fadeIn(child, 250);
            });

            parent.addEventListener('nxb:close', (event) => {
                event.stopPropagation();
                event.preventDefault();
                parent.classList.remove('open');
                child.classList.remove('open');
                link?.classList.remove('hover');
                fadeOut(child, 250);
            });

            parent.addEventListener('mouseleave', (event) => {
                event.preventDefault();
                trigger(parent, 'nxb:close');
            });

            link?.addEventListener('mouseover', (event) => {
                event.preventDefault();
                trigger(parent, 'nxb:open');
            });
        });


        [...secondLevelParents, ...mobileParents].forEach((parent) => {

            const child = parent.querySelector(':scope > ul');
            const link = parent.querySelector(':scope > a');

            // Initially open, when current or parent is current
            if (parent.classList.contains('nav-state-active')) {
                parent.classList.add('open');
                child.classList.add('open');
            }

            parent.addEventListener('nxb:open', (event) => {
                event.stopPropagation();
                event.preventDefault();
                // Open self
                parent.classList.add('open');
                slideDown(child, 250, () => {
                    child.classList.add('open');
                });

                // Close all other siblings
                [...parent.parentElement.children]
                    .filter((sibling) => sibling !== parent && sibling.matches('li.has-submenu'))
                    .forEach((sibling) => trigger(sibling, 'nxb:close'));
            });

            parent.addEventListener('nxb:close', (event) => {
                event.stopPropagation();
                event.preventDefault();
                parent.classList.remove('open');
                slideUp(child, 250, () => {
                    child.classList.remove('open');
                });
            });


            if (parent.classList.contains('has-submenu')) {

                link?.addEventListener('click', (event) => {

                    // Only open on first click. Trigger the link on the second.
                    if (!parent.classList.contains('open')) {
                        event.preventDefault();
                        trigger(parent, 'nxb:open');
                    }
                });
            }

        });


        // Handle burger button and open/close the mobile menu
        burgerButton.addEventListener('click', (event) => {
            event.preventDefault();

            if (mobileNav.classList.contains('open')) {
                trigger(mobileNav, 'nxb:close');
            } else {
                trigger(mobileNav, 'nxb:open');
            }
        });

        mobileNav.addEventListener('nxb:open', (event) => {
            event.stopPropagation();
            event.preventDefault();
            mobileNav.classList.add('open');
            slideDown(mobileNavPlaceholder, 400, () => {
                mobileNavPlaceholder.classList.add('open');
            });
            burgerButton.classList.add('active');
        });

        mobileNav.addEventListener('nxb:close', (event) => {
            event.stopPropagation();
            event.preventDefault();
            mobileNav.classList.remove('open');
            slideUp(mobileNavPlaceholder, 400, () => {
                mobileNavPlaceholder.classList.remove('open');
            });
            burgerButton.classList.remove('active');
        });
    }


    document.querySelectorAll('header').forEach((header) => {

        let narrowed = false;

        function onScroll() {
            const scrollTop = window.scrollY;

            if (scrollTop > 48) {
                if (narrowed) {
                    return;
                }
                header.classList.add('narrowed');
                narrowed = true;
            } else {
                if (!narrowed) {
                    return;
                }
                header.classList.remove('narrowed');
                narrowed = false;
            }
        }

        window.addEventListener('scroll', () => {
            onScroll();
        });
        onScroll();

    });


}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
